<template>
  <div class="sacola">
    <div class="header">
      <div class="logo-bag">
        <img src="../assets/logo.png" />
      </div>
    </div>
    <div class="component">
      <div class="items-info">
        <div>
          <h1>Sua Sacola</h1>
          <div class="itenscompras">
          <table>
            <!-- <tr>
            <ProdutosSacola :none="true" />
          </tr> -->
            <tr v-for="item in sacola" :key="item._id">
              <ProdutosSacola
                :item="item"
                :sacola="sacola"
                :deleteItem="deleteItem"
              />
            </tr>
          </table>
          </div>
        </div>
        <div class="info-buy">
          <h1>Resumo do pedido</h1>
          <div>
            <!-- <div class="info-buy-data">
              <div class="subtotal">
                <h3 class="subtotal-itens">
                  <span>Calcular Frete</span>
                </h3>
                <the-mask
                  :mask="['#####-###']"
                  v-model="cep"
                  class="text-cep"
                  placeholder="CEP"
                />
                <div class="btn-ship-find" @click="getFrete()">
                  <p>Consultar</p>
                </div>
              </div>

              <p class="error-cep" v-if="ceperror != ''">{{ceperror}}</p>

              <div class="frete" v-if="frete">
                <p>Em até XX dias úteis - R$ XX,XX</p>
              </div>
            </div> -->
            <div class="info-buy-data">
              <div class="subtotal">
                <h3 class="subtotal-itens">
                  <span>Total</span>
                </h3>
                <h3 class="subtotal-preco">
                  R$ {{ total.toFixed(2).replace(".", ",") }}
                </h3>
              </div>
              <div class="continuar-div">
                <button
                  type="button"
                  id="continuar_btn"
                  disabled
                  v-on:click="continuar()"
                >
                  Concluir compra
                </button>
              </div>

              <div>
                <a href="/">
                  <p class="btn-continue-buy">Continuar comprando</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { TheMask } from "vue-the-mask";
import ProdutosSacola from "../components/ProdutosSacola";
export default {
  name: "Sacola",
  components: {
    // TheMask,
    ProdutosSacola,
  },
  data() {
    return {
      sacola: [],
      cep: "",
      ceperror: "",
      frete: null,
      total: 0,
      qnt: 0,
    };
  },
  mounted() {
    if (localStorage.getItem("sacola")) {
      try {
        let sacola_ = JSON.parse(localStorage.getItem("sacola"));
        this.sacola = sacola_;

        let total_ = 0;
        let qnt_ = 0;
        let limpar = false;

        for (let e of sacola_) {
          let produto = new Date(e.data);
          let dia = new Date();
          if (dia - produto > 2) {
            //10800000){
            limpar = true;
          }
          if (e.item.preco.preco_desconto) {
            total_ += e.item.preco.preco_desconto * e.qntSelecionado;
          } else {
            total_ += e.item.preco.preco_venda * e.qntSelecionado;
          }

          qnt_ += e.qntSelecionado;
        }

        if (limpar) this.limpar();

        this.total = total_;
        this.qnt = qnt_;
      } catch (e) {
        localStorage.removeItem("sacola");
      }
    }
  },
  methods: {
    limpar() {
      try {
        localStorage.setItem("sacola", []);
      } catch (err) {
        alert("Não foi possível limpar!");
      }
    },
    deleteItem(item) {
      let sac = this.sacola;
      let new_sacola = sac.filter((e) => e.item._id !== item.item._id);

      //this.sacola = new_sacola;
      this.sacola = new_sacola;
      this.calcularTotal(new_sacola);

      const sav = JSON.stringify(new_sacola);
      localStorage.setItem("sacola", sav);

      this.$forceUpdate();
    },
    calcularTotal(sacola_) {
      let total_ = 0;
      let qnt_ = 0;

      for (let e of sacola_) {
        if (e.item.preco.preco_desconto) {
          total_ += e.item.preco.preco_desconto * e.qntSelecionado;
        } else {
          total_ += e.item.preco.preco_venda * e.qntSelecionado;
        }

        qnt_ += e.qntSelecionado;
      }

      this.total = total_;
      this.qnt = qnt_;
    },
    continuar() {
      alert("Compras indisponíveis no momento!");
      // if (this.frete) {
      let user = localStorage.getItem("usuario");

      if (this.sacola && this.sacola.length > 0) {
        if (user) {
          // Continuar o processo
          this.$router.push("/checkout");
        } else {
          // Enviar para a tela de login
          this.$router.push("/login?l=true");
        }
      }
      // } else{
      // this.ceperror = "O CEP está vazio"
      // }
    },
  },
};
</script>

<style>
.sacola {
  background-color: #efefef;
}

.sacola .header {
  background-color: #fff;
  border-bottom: 1px solid #ededed;
  z-index: 2;
}

.sacola .component {
  width: 90%;
  margin: 30px auto;
  padding: 20px 0px;
  padding-bottom: 100px;
  border-bottom: 1px solid #ededed;
  z-index: 2;
}

.sacola .component table th {
  background-color: white;
}

.sacola h1 {
  text-align: left;
  margin-bottom: 30px;
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
}

.sacola table {
  border-collapse: collapse;
  width: 100%;
}

.sacola .component .info-buy .info-buy-data {
  background-color: #fff;
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.sacola .component .info-buy .info-buy-data .error-cep {
  color: red;
  text-align: right;
  padding-right: 20px;
}

.sacola .component .info-buy .info-buy-data .subtotal {
  align-items: center;
}

.sacola .component .info-buy .info-buy-data .subtotal .text-cep {
  border: 1px solid #000;
  padding: 10px;
}

.sacola .component .info-buy .info-buy-data .subtotal .btn-ship-find {
  cursor: pointer;
  background-color: #4e4e4e;
  padding: 10px 0px;
  color: #fff;
}

table th {
  border: none;
}

.sacola .component .items-info {
  display: flex;
}

.sacola .component .info-buy {
  width: 50%;
  margin-left: 40px;
}

.sacola .component .info-buy .info-buy-data .frete {
  text-align: left;
  margin-left: 20px;
}

.sacola td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.sacola .logo-bag {
  width: 100px;
  padding: 20px;
  margin-left: 30px;
}

.sacola tr:nth-child(even) {
  background-color: #dddddd;
}

.sacola .component .items-info .info-buy .info-buy-data .subtotal {
  display: flex;
  padding: 20px;
}

.sacola
  .component
  .items-info
  .info-buy
  .info-buy-data
  .subtotal
  .subtotal-itens {
  text-align: left;
}

.sacola
  .component
  .items-info
  .info-buy
  .info-buy-data
  .subtotal
  .subtotal-preco {
  text-align: right;
}

.sacola .component .items-info .info-buy .info-buy-data .continuar-div {
  width: 100%;
  padding-bottom: 20px;
}

.sacola .component .items-info .info-buy .info-buy-data .btn-continue-buy {
  text-decoration: underline;
  padding-bottom: 20px;
  font-size: 14px;
}

#subtotal {
  display: inline-flex;
  justify-content: flex-end;

  margin-top: 10px;
  margin-bottom: 10px;
}

#subtotal_itens {
  display: block;
  width: 200px;
  text-align: right;
  font-weight: 500;
}

#subtotal_preco {
  display: block;
  color: #8d816b;
  width: 110px;
  text-align: right;
}

#subtotal span {
  font-weight: bold;
}

#continuar_div {
  display: inline-flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-bottom: 20px;
}

#continuar_btn {
  padding: 10px;
  font-size: 20px;
  color: #ffffff;
  font-weight: 600;
  border: none;
  background-color: yellowgreen;
}

#continuar_btn:disabled {
  background-color: #cccccc;
}

.sacola .component .items-info .itenscompras {
  height: 100%;
  background-color: white;
}

@media screen and (max-width: 800px) {
  .sacola .component .info-buy {
    margin-left: 0px;
    margin-top: 20px;
  }

  .sacola .component .items-info {
    display: flex;
    flex-direction: column;
  }

  .sacola .component .info-buy .info-buy-data {
    min-width: 337px;
  }
}
</style>
